import { render, staticRenderFns } from "./Canvas.vue?vue&type=template&id=c73a5bf0&"
import script from "./Canvas.vue?vue&type=script&lang=ts&"
export * from "./Canvas.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports